var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 30,
    fill: "#292D32",
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9707 39V40C42.9707 41.65 42.9707 43 39.9707 43H25.9707C22.9707 43 22.9707 41.65 22.9707 40V39C22.9707 38.45 23.4207 38 23.9707 38H41.9707C42.5207 38 42.9707 38.45 42.9707 39Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.7195 34V38H24.2695V34C24.2695 30.16 26.9795 26.95 30.5895 26.18C31.1295 26.06 31.6895 26 32.2695 26H33.7195C34.2995 26 34.8695 26.06 35.4095 26.18C39.0195 26.96 41.7195 30.16 41.7195 34Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 25.5C35.5 25.74 35.47 25.96 35.41 26.18C34.87 26.06 34.3 26 33.72 26H32.27C31.69 26 31.13 26.06 30.59 26.18C30.53 25.96 30.5 25.74 30.5 25.5C30.5 24.12 31.62 23 33 23C34.38 23 35.5 24.12 35.5 25.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32.75H30C29.59 32.75 29.25 32.41 29.25 32C29.25 31.59 29.59 31.25 30 31.25H36C36.41 31.25 36.75 31.59 36.75 32C36.75 32.41 36.41 32.75 36 32.75Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservRequest);
export default __webpack_public_path__ + "static/media/reserv-request.3f0170741ba4e7e4368efdead28cddce.svg";
export { ForwardRef as ReactComponent };